import React from 'react';

export const Toplist = () => (
  <svg
    width={'55'}
    height={'57'}
    viewBox="0 0 57 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.1198 1.81421L31.3391 9.44114L39.327 9.95712L33.069 15.3757L35.0457 23.132L27.9589 18.8537L21.1939 23.132L23.0713 15.0688L16.9126 9.95712L25.1608 9.25159L28.1198 1.81421Z"
      fill="#2ED3B7"
      stroke="#297FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.733 27.7729H37.507V42.3288H55.24V55.7067H1V36.2874H18.733V27.7729V27.7729Z"
      stroke="#297FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.1565 36.9161L28.5096 33.5645V42.9845"
      stroke="#297FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.2451 43.5532H31.0834"
      stroke="#297FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.5071 37.4426V54.2805"
      stroke="#297FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.7329 32.6484V53.9061"
      stroke="#297FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
